import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import DataTable from '../../DataTable';
import Spinner from '../../Spinner';
import {observable} from 'mobx';

@inject('imageSourceStore')
@observer
class ImageSourceList extends Component {
  constructor(props) {
    super(props);
    this.handleDelete = this.handleDelete.bind(this);
  }

  @observable images = [];

  actions = [
    { label: 'View', link: '/idaq/image_source/{id}/devices' },
  ];

  componentWillMount() {
    const { imageSourceStore} = this.props;

    imageSourceStore.fetchItems();
  }

  handleDelete(idOrIds) {
    this.props.imageSourceStore.removeItems(idOrIds);
  }

  render() {
    const { imageSourceStore, main, sidebar } = this.props;

    if(imageSourceStore.isLoading) return <Spinner/>;

    let items = imageSourceStore.items.map(item => Object.assign({}, item, {protocol: imageSourceStore.protocolOptions.find(p => +p.id === +item.protocol)}));

    if(!main || !sidebar) return (
      <div>
        <DataTable
          data={items}
          slug={'idaq/image_source'}
          columns={[
            { key: 'id', label: 'ID' },
            { key: 'name', label: 'Name' },
            { key: 'protocol.name', label: 'Protocol' },
            { key: 'address', label: 'Address' },
            { key: 'timezone', label: 'Timezone' },
          ]}
          actions={this.actions}
          onDelete={this.handleDelete}
          allowAdd
          allowEdit
          allowDelete
          resource='idaq'
        />
        {this.props.children}
      </div>
    );

    return (
      <div className='inline-grid'>
        <div className='side-table'>
          <DataTable
            data={items}
            slug={'idaq/image_source'}
            columns={[
              { key: 'id', label: 'ID' },
              { key: 'name', label: 'Name' },
            ]}
            actions={this.actions}
            caption="Image Sources"
            resource='idaq'
          />
        </div>
        <div className='flex-grow'>{main}</div>
      </div>
    )
  }
}

export default ImageSourceList;



// WEBPACK FOOTER //
// ./src/components/IDaq/ImageSource/ImageSourceList.js